import i18n from '@/plugins/i18n';
import { ERROR_CODES, PUBLIC_MESSAGES } from '@common/constants/messages';
import { backendMessageKey } from '@/utils/backend-message-i18n';

/* Texto do dicionário pelo código, no idioma da interface (backendErrors.<código>). */
const dictionaryText = (errorCode, params) => i18n.t(backendMessageKey(errorCode), params);

/**
 * Mensagem de tela para erro de login (senha, provedor de identidade, vínculo).
 *
 * Sai sempre do dicionário pelo código (errorCode): o authenticator ainda responde algumas
 * recusas antigas com texto em inglês, que nunca pode chegar ao usuário. {provedor} vira o
 * nome do provedor (Google, LinkedIn...).
 *
 * @param {Object} error erro do axios
 * @param {String} [providerLabel] nome do provedor na tela
 * @returns {String}
 */
export function authErrorMessage(error, providerLabel) {
  const response = error && error.response;

  if (!response) return i18n.t('http.authErrorUi.noConnection');

  const errorCode = response.data && response.data.errorCode;

  if (errorCode && PUBLIC_MESSAGES[errorCode])
    return dictionaryText(errorCode, { provedor: providerLabel || i18n.t('http.authErrorUi.genericProvider') });

  if (response.status === 429) return dictionaryText(ERROR_CODES.AUTH_TOO_MANY_ATTEMPTS);

  if (response.status === 401) return dictionaryText(ERROR_CODES.AUTH_INVALID_CREDENTIALS);

  return i18n.t('http.authErrorUi.unexpected');
}
